export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";